export const assistant = {
routeTitle: "Assistant des opérations",
routeSubtitle: "Intelligence opérationnelle pour vos actifs",
inputModeText: "Texte d’abord",
widget: {
showLess: "Afficher moins",
showMore: "Afficher plus",
openAssistant: "Ouvrir l’assistant",
live: "En direct",
assistantLabel: "Assistant",
headerSubtitle: "Demandez, inspectez, planifiez, réaffectez ou créez du travail sans quitter cet écran.",
newConversation: "Nouvelle conversation",
close: "Fermer",
newThread: "Nouveau fil",
loadingConversation: "Chargement de la conversation…",
emptyTitle: "Chat opérationnel permanent",
emptyBody: "Commencez par une instruction naturelle. L'assistant peut répondre aux questions, proposer des actions et attendre votre confirmation lorsqu'un changement est important.",
actorYou: "Vous",
actorAssistant: "Assistant",
usedWorkspaceData: "Données de l'espace de travail utilisées",
recommendationFallbackTitle: "Recommandation",
dictationInserting: "Insertion du texte…",
dictationFinishing: "Fin de la dictée…",
dictationHeard: "Entendu : {{transcript}}",
dictationListening: "Écoute…",
messageInputLabel: "Envoyer un message à l'assistant",
messagePlaceholder: "Posez une question ou dites à l'assistant quoi faire",
messagePlaceholderShort: "Question ou demande…",
stopDictation: "Arrêter la dictée",
dictateMessage: "Dicter un message",
sendingMessage: "Envoi d'un message",
sendMessage: "Envoyer un message",
sending: "Envoi…",
send: "Envoyer",
composerHintPhone: "Appuyez sur le microphone pour dicter.",
composerHintDesktop: "Appuyez sur le microphone pour dicter. « Enter » envoie sur les claviers matériels ; `Shift + Enter` ajoute une nouvelle ligne.",
},
conversation: {
newSession: "Nouvelle session",
inputModeLabel: "Mode de saisie : {{mode}}",
modeHint: "Transcription vocale prête ; la saisie de texte est active pour le moment.",
retry: "Réessayer",
loadingHistory: "Chargement de l'historique de l'assistant...",
emptyTitle: "Copilote opérationnel",
emptyBody: "Demandez des ébauches de check-lists, la planification des inspections, la création d'interventions, l'état des travaux, la réaffectation, l'explication des risques ou les recommandations pour l'étape suivante.",
actorYou: "Vous",
actorAssistant: "Assistant",
messagePlaceholder: "Demander à l'assistant de créer, expliquer, inspecter, recommander ou réaffecter",
},
quickPrompts: {
attention: "Qu'est-ce qui demande mon attention en ce moment ?",
inspectionTemplates: "Où gérer les check-lists ?",
requestsTriage: "Quelles demandes doivent être triées ?",
overdueJobs: "Afficher les interventions en retard",
assetNextStep: "Que dois-je faire ensuite pour cet actif ?",
assetOverdueInspections: "Des inspections sont-elles en retard pour cet actif ?",
assetRiskSummary: "Résumer les risques et le travail en cours sur cet actif",
scheduleNextInspection: "Planifier la prochaine inspection",
assetTopNextStep: "Recommander l'étape suivante la plus prioritaire pour cet actif",
assetOpenJobsFirst: "Quelles interventions ouvertes dois-je examiner en premier ?",
shouldScheduleInspection: "Dois-je planifier une inspection ?",
requestSummarize: "Résumer cette demande et suggérer une réponse",
requestToJob: "Convertir cette demande en intervention",
requestMissingInfo: "Quelles informations manquent encore pour commencer le travail ?",
requestOwner: "Qui devrait prendre en charge cette demande ?",
requestFastestPath: "Quel est le moyen le plus rapide de convertir cette demande ?",
requestDraftResponse: "Rédiger une réponse professionnelle au demandeur",
requestJobOrInspection: "Faut-il en faire une intervention ou une inspection ?",
inspectionFailedFindings: "Résumer les constats non conformes et suggérer des interventions de suivi",
inspectionMissingEvidence: "Quelles preuves manquent dans cette inspection ?",
inspectionHighestRisk: "Expliquer les points non conformes les plus à risque",
inspectionJobsFromUrgent: "Créer des interventions à partir des constats urgents",
jobBlocking: "Qu'est-ce qui bloque l'achèvement de cette intervention ?",
jobNextUpdate: "Suggérer la prochaine mise à jour à publier",
jobWhoElse: "Qui d'autre devrait participer à cette intervention ?",
jobFollowUp: "Quels travaux de suivi pourraient être nécessaires ?",
jobNextStepToClose: "Recommander l'étape suivante pour clôturer cette intervention",
jobDraftCompletionNote: "Rédiger une note de fin d'intervention",
jobCreateFollowUp: "Dois-je créer une intervention de suivi ?",
templateImprove: "Comment améliorer cette check-list ?",
templateMissingChecks: "Quels contrôles manquent pour ce type d'actif ?",
templateWeekly: "Générer un check-list hebdomadaire pratique",
templateWhereManage: "Où gérer les check-lists dans l'application ?",
},
  card: {
    edit: 'Modifier',
    doneEditing: 'Terminer',
    editHint: 'Modifiez ces champs avant de confirmer.',
    confirming: 'Confirmation…',
    dismiss: 'Ignorer',
    working: 'En cours…',
    undo: 'Annuler',
    undoing: 'Annulation…',
    undone: 'Annulé',
    undoHint: 'Vous pouvez annuler pendant 10 minutes.',
    edited: 'Modifié',
    fields: {
      name: 'Nom',
      description: 'Description',
      placeType: 'Type de lieu',
      address: 'Adresse',
      externalId: 'Référence',
      code: 'Code',
      scheduledDate: 'Échéance (date et heure)',
      notes: 'Notes',
      title: 'Titre',
      dueDate: 'Échéance (date et heure)',
      estimatedCost: 'Estimation',
      note: 'Mise à jour',
      responseText: 'Réponse',
    },
  },
  chart: {
    summary_one: '{{title}} : {{from}}',
    summary_many: '{{title}} : de {{from}} à {{to}}, {{count}} points',
    summary_other: '{{title}} : de {{from}} à {{to}}, {{count}} points',
  },
  context: {
    selectedAssets_one: "Question sur {{count}} actif sélectionné",
    selectedAssets_many: "Question sur {{count}} actifs sélectionnés",
    selectedAssets_other: "Question sur {{count}} actifs sélectionnés",
    leaveOut: "Laisser la sélection de côté",
  },
  memory: {
    title: "Ce que retient l’assistant",
    intro: "Des préférences pour tout l’espace de travail, comme la façon dont vous nommez les choses ou qui reçoit d’habitude un type d’intervention. L’assistant les suit quand il répond. Tout le monde dans l’espace de travail peut les voir.",
    empty: "Rien pour l’instant. Ajoutez-en une ici ou demandez à l’assistant, par exemple « Retiens que les interventions de sécurité gaz vont à Northside Heating ».",
    addPlaceholder: "Quelque chose que l’assistant doit retenir",
    add: "Ajouter",
    edit: "Modifier",
    save: "Enregistrer",
    cancel: "Annuler",
    forget: "Oublier",
    viaAssistant: "Ajouté via l’assistant",
    added: "Ajouté par quelqu’un de l’espace de travail",
    full: "L’assistant retient {{max}} éléments, le maximum. Oubliez-en un pour en ajouter un autre.",
    saveFailed: "Ce n’a pas été enregistré. Vous ne pouvez modifier que ce que vous avez ajouté, sauf si vous êtes administrateur de l’espace de travail.",
  },
  offline: {
    waiting: "Vous êtes hors ligne. Ce sera envoyé quand vous serez de nouveau en ligne.",
    sending: "De nouveau en ligne. Envoi…",
    fromGuide: "En attendant, le guide de l’app peut vous aider :",
    discard: "Ne pas envoyer",
    photoNeedsConnection: "Une photo nécessite une connexion. Retirez-la pour que la question parte dès votre retour en ligne, ou réessayez à ce moment-là.",
    queueFull: "10 questions attendent déjà. Attendez d’être de nouveau en ligne.",
  },
  stream: {
    thinking: "En cours…",
    lookingUp_one: "Recherche en cours ({{count}} pour l’instant)…",
    lookingUp_many: "Recherche en cours ({{count}} pour l’instant)…",
    lookingUp_other: "Recherche en cours ({{count}} pour l’instant)…",
  },
  voice: {
    readAloud: "Lire les réponses à voix haute",
    stopReading: "Ne plus lire les réponses",
    readingAloud: "Les réponses sont lues à voix haute.",
    handsFree: "Mains libres",
    handsFreeOn: "Mains libres : après chaque réponse, il écoute votre question suivante.",
  },
  briefing: {
    title: 'Cette semaine',
    stopSuggesting: 'Ne plus suggérer ceci',
    hideWeek: 'Masquer jusqu’à la semaine prochaine',
    turnOff: 'Désactiver le point hebdomadaire',
    settingsTitle: 'Votre point hebdomadaire',
    settingsIntro: 'Un court résumé de votre semaine et quelques questions suggérées en haut de l’assistant. C’est votre propre réglage.',
    on: 'Activé',
    off: 'Désactivé',
    suggestionsOff_one: '{{count}} type de suggestion est désactivé.',
    suggestionsOff_many: '{{count}} types de suggestion sont désactivés.',
    suggestionsOff_other: '{{count}} types de suggestion sont désactivés.',
    suggestionsBackOn: 'Réactiver les suggestions',
  },
  photo: {
    add: "Ajouter une photo",
    replace: "Remplacer la photo",
    remove: "Retirer la photo",
    attached: "Photo jointe. L'assistant la lit une fois et ne la conserve pas.",
    addTitle: "Ajouter une photo",
    addBody: "Prenez une photo ou choisissez-en une. L'assistant lit les plaques signalétiques, les relevés et les dégâts.",
    take: "Prendre une photo",
    choose: "Choisir une photo",
    cancel: "Annuler",
    permissionTitle: "Autorisation requise",
    cameraPermissionBody: "Autorisez l'accès à l'appareil photo dans Réglages pour prendre une photo pour l'assistant.",
    libraryPermissionBody: "Autorisez l'accès aux photos dans Réglages pour choisir une photo pour l'assistant.",
    failedTitle: "Photo non ajoutée",
    failedBody: "Impossible d'ouvrir cette photo. Essayez-en une autre.",
    defaultMessage: "Que montre cette photo ?",
  },
  activity: {
    title: 'Activité de l\'assistant',
    subtitleAdmin: 'Toutes les modifications faites via l\'assistant dans cet espace',
    subtitleMember: 'Les modifications que vous avez faites via l\'assistant',
    policyTitle: 'Qui peut faire des modifications via l\'assistant',
    policyIntroAdmin: 'Chacun garde ses propres droits : l\'assistant ne fait que ce que la personne pourrait faire dans l\'application.',
    policy: {
      everyone: 'Tout le monde',
      admins: 'Propriétaires et admins',
      nobody: 'Personne',
    },
    policyHelp: {
      everyone: 'Les membres peuvent confirmer les modifications préparées par l\'assistant, selon leurs droits.',
      admins: 'Les membres peuvent poser des questions ; seuls les propriétaires et admins confirment des modifications.',
      nobody: 'L\'assistant répond et conseille mais ne modifie rien. Les demandes de fonctionnalité partent toujours.',
    },
    policyMember: {
      everyone: 'Vous pouvez confirmer les modifications préparées par l\'assistant, selon vos droits.',
      admins: 'Dans cet espace, seuls les propriétaires et admins font des modifications via l\'assistant. Vous pouvez toujours lui poser des questions.',
      nobody: 'Cet espace a désactivé les modifications via l\'assistant. Vous pouvez toujours lui poser des questions.',
    },
    saving: 'Enregistrement…',
    saveFailed: 'Impossible d\'enregistrer ce réglage.',
    loadFailed: 'Impossible de charger l\'activité de l\'assistant.',
    refresh: 'Actualiser',
    count_one: '{{count}} modification',
    count_many: '{{count}} modifications',
    count_other: '{{count}} modifications',
    empty: 'Aucune modification faite via l\'assistant pour l\'instant.',
    status: {
      executed: 'Fait',
      failed: 'Échec',
      undone: 'Annulé',
    },
    byYou: 'par vous',
    byPerson: 'par {{name}}',
  },
};
